const AuthReducer = (state, action) => {
    switch(action.type) {
        case 'LOGIN_START' :
            return ({
                user: null,
                isFetching: true,
                error: false
            })
        case 'LOGIN_SUCCESS' :
            return ({
                user: action.payload,
                isFetching: false,
                error: false
            })
        case 'LOGIN_FAILURE' :
            return ({
                user: null,
                isFetching: false,
                error: action.payload
            })
        case 'UPDATE_USER' :
            return ({
                user: action.payload,
                isFetching: false,
                error: false
            })
        case 'NON_EXISTENT_TOKEN' :
            return ({
                user: null,
                isFetching: false,
                error: false
            })
        case 'EXPIRED_SESSION' :
            return ({
                user: null,
                isFetching: false,
                error: false
                // error: {
                //     response: {
                //         data: {
                //             msg : "The session has expired"
                //         }
                //     }
                // },
            })
        default :
            return state

    }
}

export default AuthReducer